import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import Form from '~/components/blocks/acf/Form';

const FormBlock = ({ attributes, blockForm: { formId, usePanel } }) => (
    <Form {...{ formId, usePanel, attributes }} />
);

export default FormBlock;

FormBlock.propTypes = {
    blockForm: PropTypes.shape({
        formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
            .isRequired,
        usePanel: PropTypes.bool
    }).isRequired
};

export const query = graphql`
    fragment FormBlockFragment on WpAcfFormBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockForm {
            formId
            usePanel
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Form Block',
        props: {
            name: 'acf/form',
            blockForm: {
                formId: 1,
                usePanel: false
            }
        }
    },
    {
        variant: 'Form Block with Panel',
        props: {
            name: 'acf/form',
            blockForm: {
                formId: 1,
                usePanel: true
            }
        }
    }
];
